import {SpriteView} from '../../ui_canvas_engine/SpriteView'
import {PIXI} from '@colonist/pixi'
import {Sprites} from '../UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'

export class UIGameMapDiceHighlightView extends SpriteView {
    private readonly originalParent: PIXI.Container

    constructor(x: number, y: number, size: number, container: PIXI.Container) {
        const inactiveTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_highlight_square_yellow)
        super(x, y, size, size, container, inactiveTexture)
        this.originalParent = container
    }

    hide() {
        if(this.parent == undefined) return
        this.parent.removeChild(this)
    }

    show() {
        if(this.parent != undefined) return
        this.originalParent.addChild(this)
    }
}
